import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { processType } from '../../../constants/options.constant';
import validCharacters from '../../../constants/valid-characters';
import { CheckItemFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { IUserFilter } from '../../../models/IUserFilter';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import {
  ClearFilterIcon,
  FilterIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import { ICheckItemFilter } from '../../../models/ICheckItemFilter';
import { p } from 'msw/lib/core/GraphQLHandler-jOzqbxSK';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: any;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
  processOptions: any[];
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if(!isOpen){
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={{
          ...props.initialValues,
          ProcessName: String(props.processOptions?.find(opt => opt.value === props.initialValues.ProcessName)?.id || '-1')
        }}
        enableReinitialize
        // validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: ICheckItemFilter, { resetForm, setFieldValue }) => {
          const selected = props.processOptions?.find(
            (opt) => opt.id === Number(values.ProcessName)
          );
          props.submitHandler({ ...values, ProcessName: selected ? (selected.id === -1 ? '' : selected.value) : '' });
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values }) => {
          return (
            <Dropdown
              className={`Filter-DID ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas(
                      //   { ...ProcessFilterInitialState },
                      //   true
                      // );
                      resetForm();
                      setShowDropdown(!showDropdown);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-x"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                            </svg>
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        <Col md={12}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="template_name"
                              htmlFor="TemplateName"
                            />
                            <Field
                              data-testid="TemplateName"
                              className="form-control"
                              name="TemplateName"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="process_name"
                              htmlFor="ProcessName"
                            />

                            <Field
                              name="ProcessName"
                              as={FormikFormSelect}
                              options={props.processOptions ?? []}
                              data-testid="ProcessName"
                              className="form-control"
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        {/* <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="short_name"
                            />
                            <Field
                              data-testid="ShortName"
                              className="form-control"
                              name="ShortName"
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col> */}
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                     <div style={{ visibility: props.isFilterCleared ? 'hidden' : 'visible' }}>
                    <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(CheckItemFilterInitialState, true);
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                    </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={(JSON.stringify(props.initialValues) === JSON.stringify(values)) || (!values.TemplateName && (!values.ProcessName || values.ProcessName === '-1'))}
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
